module.exports = __webpack_public_path__ + "img/anglePlus.ceca3202.svg";